import { styled } from "@linaria/react"

export const Stack = styled.div<{
  direction?: "row" | "column"
}>`
  display: flex;
  flex-direction: ${(props) => String(props.direction === "row" ? "row" : "column")};
  gap: var(--spacing);
`
